import { connect } from 'react-redux'
import * as actions from '../../../actions'
import * as api from '../../../actions/api'
import MenuAppBar from '../components/MenuAppBar'

const mapStateToProps = (state) => {
  const { user, isAuthStateChange, signUp, auth0 } = state.authentication
  const { width } = state.window
  const { language } = state.user
  return ({
    user,
    width,
    isAuthStateChange,
    signUp,
    auth0,
    language
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return ({
    fetchErrorMessagePost: (errorMessage) => {
      dispatch(api.fetchErrorMessagePost(errorMessage))
    },
    resize: () => {
      dispatch(actions.window.resize(window.innerWidth, window.innerHeight))
    },
  })
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MenuAppBar)



// WEBPACK FOOTER //
// ./src/Parts/MenuAppBar/containers/MenuAppBar.js